// extracted by mini-css-extract-plugin
module.exports = {"whoami":"WhoAmI_whoami__2T1-W","profile":"WhoAmI_profile__UV0cD","links":"WhoAmI_links__3F3PC"};